import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LayoutTemplateType } from 'libs/core/src/lib/enum/layout-template.enum';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/lib/injection.tokens';
import { FlowType } from 'libs/core/src/lib/model/component/steps/flow-type.model';
import { LanguageViewModel } from 'libs/core/src/lib/model/view-model/language/language.view.model';
import { FlowService } from 'libs/core/src/lib/service/flow.service';
import { ThemeService } from 'libs/core/src/lib/service/theme.service';
import { tap } from 'rxjs';

@UntilDestroy()
@Component({
  template: ''
})
export class LayoutComponent implements OnInit {
  @Input() languageList: LanguageViewModel[];
  @Input() templateType: LayoutTemplateType;

  layoutClass = 'layout-standard';
  themeClass = '';

  constructor(
    @Inject(ENVIRONMENT_TOKEN) protected environment: any,
    private renderer: Renderer2,
    private flowService: FlowService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.changeLayout(this.flowService.FlowType);
    this.flowService.flowType$
      .pipe(
        tap((flow) => this.changeLayout(flow)),
        untilDestroyed(this)
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.removeCurrentLayoutClass();
  }

  private changeLayout(flow: FlowType) {
    this.removeCurrentLayoutClass();

    this.layoutClass = `layout-${flow}`;
    this.renderer.addClass(document.body, this.layoutClass);

    if (flow === FlowType.Voucher) {
      const activeTheme = this.environment.voucherShop?.themes?.find((theme) => theme.key === this.environment.voucherShop?.activeTheme);
      if (activeTheme) {
        this.themeClass = `theme-${activeTheme.key}`;
        this.renderer.addClass(document.body, this.themeClass);

        this.themeService.setTheme(activeTheme);
      }
    }
  }

  private removeCurrentLayoutClass() {
    if (this.layoutClass) {
      this.renderer.removeClass(document.body, this.layoutClass);
    }
    if (this.themeClass) {
      this.renderer.removeClass(document.body, this.themeClass);
    }

    this.themeService.clearTheme();
  }
}
